import React from 'react';
import { FormattedMessage } from 'react-intl'
import Link from '../components/IntlLink'
import arrowDown from '../images/arrow-circle-down.svg'

class NewsCategories extends React.Component {
  constructor(props) {
    super(props);
    this.state = {dropdownIsOpen: false}
  }

  handleOpenDropdown(e) {
    e.preventDefault();
    this.setState({dropdownIsOpen: !this.state.dropdownIsOpen})
  }

  render() {
    const { dropdownIsOpen } = this.state
    return(
      <ul className="news__nav__inner">
        <li className="news__nav__link">
          <Link to={`/p/news`} className="news__nav__link--category" >
            <FormattedMessage id="news.categories" />
          </Link>
          <Link
            to="#"
            onClick={(e) => this.handleOpenDropdown(e)}
            className="news__nav__arrow-down"
            >
            <img src={arrowDown}/>
          </Link>
        </li>
        {
          dropdownIsOpen &&
            this.props.allCategories.map(category => {
              return (
                <li className="news__nav__link--mobile" key={`${category.slug}-mobile`}>
                  <Link to={`/category/${category.slug}`}>
                    {category.title}
                  </Link>
                </li>
              );
            })
        }
        {
          this.props.allCategories.map(category => {
            return (
              <li className="news__nav__link--desktop" key={`${category.slug}-desktop`}>
                <Link to={`/category/${category.slug}`}>
                  {category.title}
                </Link>
              </li>
            );
          })
        }
      </ul>
    )
  }
}

export default NewsCategories;



// WEBPACK FOOTER //
// ./src/components/NewsCategories.js